import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer" dir="ltr">
      <p className="footer__license">
        تطبيق تحرر مرخص من وزارة التجارة والمركز السعودي للأعمال ووزارة الصحة
      </p>
      <div className="footer__links">
        <Link to="/privacy-policy" className="footer__link">
          سياسة الخصوصية
        </Link>
      </div>
      <p className="footer__copy">
        © تحرر 2025. جميع الحقوق محفوظة
      </p>
    </footer>
  );
}
